import Layout from '@/views/layout/Layout'
import  organizationMge from '@/views/organizationMge/index'

export default {
  // componentModule:{
  //   "V3_0_IQManageCenter_OrganizationManage1":{
  //     name:"V3_0_IQManageCenter_OrganizationManage1",
  //     hidden:true,
  //     children:[]
  //   },
  //   "V3_0_IQManageCenter_OrganizationManage":{
  //     name:"V3_0_IQManageCenter_OrganizationManage",
  //     hidden:true,
  //     children:[]
  //   },
  //   'V3_0_IQManageCenter_LoggerManage':{
  //     name:"V3_0_IQManageCenter_LoggerManage",
  //     hidden:true,
  //     children:[]
  //   },
  //   'V3_0_IQManageCenter_DeviceManage':{
  //     name:"V3_0_IQManageCenter_DeviceManage",
  //     hidden:true,
  //     children:[]
  //   },
  //   'V3_0_IQManageCenter':{
  //     name:"V3_0_IQManageCenter",
  //     hidden:true,
  //     children:[]
  //   },
  //   'V3_0_IQManageCenter_Home':{
  //     name:"V3_0_IQManageCenter_Home",
  //     hidden:true,
  //     child:[]
  //   },
  //   'V3_0_IQManageCenter_SettingManage':{
  //     name:"V3_0_IQManageCenter_SettingManage",
  //     hidden:true,
  //     children:[]
  //   },
  //   'V3_0_IQManageCenter_MediaDeviceManage':{
  //     name:"V3_0_IQManageCenter_MediaDeviceManage",
  //     hidden:true,
  //     children:[]
  //   },
  //   'V3_0_IQManageCenter_AuthManage':{
  //     name:"V3_0_IQManageCenter_AuthManage",
  //     hidden:true,
  //     children:[]
  //   },
  //   'V3_0_IQManageCenter_UserManage':{
  //     name:"V3_0_IQManageCenter_UserManage",
  //     hidden:true,
  //     children:[]
  //   },
  //   'V3_0_IQManageCenter_CloudSpaceManage':{
  //     name:"V3_0_IQManageCenter_CloudSpaceManage",
  //     hidden:true,
  //     children:[]
  //   },
  //   'V3_0_IQControlCenter':{
  //     name:"V3_0_IQControlCenter",
  //     hidden:true,
  //     children:[]
  //   },
  // },
  // routesModule:[
  //   {
  //     name:'',
  //     routes:{
  //       path: '',
  //       components: Layout,
  //       redirect: 'dashboard',
  //       children: [{
  //         path: 'dashboard',
  //         components: () => import('@/views/dashboard/index'),
  //         name: 'dashboard',
  //         meta: { title: 'dashboard', icon: 'dashboard' }
  //       }]
  //     }
  //   },
  //   {
  //     name:'V3_0_OrganizationManage',
  //     routes:{
  //       path: '',
  //       components: Layout,
  //       redirect: 'organizationMge',
  //       children: [{
  //         path: 'organizationMge',
  //         components: () => import('@/views/organizationMge/index'),
  //         name: 'organizationMge',
  //         meta: { title: 'organizationMge', icon: 'icon', noCache: true},
  //         setName:'V3_0_OrganizationManage'
  //       }]
  //     },
  //   },
  //   {
  //     name:'V3_0_OrganizationManage1',
  //     routes: {
  //       path: '',
  //       components: Layout,
  //       redirect: 'organizationShoolIndexMge',
  //       children: [{
  //         path: 'organizationShoolIndexMge',
  //         components: () => import('@/views/organizationMge/shoolIndex'),
  //         name: 'organizationShoolIndexMge',
  //         meta: { title: 'organizationMge', icon: 'icon', noCache: true },
  //         setName:'V3_0_OrganizationManage1'
  //       }]
  //     },
  //   },
  //   {
  //     name:'V3_0_UserManage',
  //     routes:{
  //       path: '',
  //       components: Layout,
  //       redirect: 'userMge',
  //       children: [{
  //         path: 'userMge',
  //         components: () => import('@/views/userMge/index'),
  //         name: 'userMge',
  //         meta: { title: 'userMge', icon: 'icon', noCache: true },
  //         setName:'V3_0_UserManage'
  //       }]
  //     },
  //   },
  //   {
  //     name:'V3_0_DeviceManage',
  //     routes:{
  //       path: '',
  //       components: Layout,
  //       redirect: 'authorityMge',
  //       name: 'authorityMge',
  //       meta: {
  //         title: 'authorityMge',
  //         icon: 'component',
  //       },
  //       setName:'V3_0_DeviceManage',
  //       children: [
  //         { path: 'authorityMge', components: () => import('@/views/authorityMge/index'), name: 'authorityMge', meta: { title: 'authorityMge' },setName:'V3_0_DeviceManage_Operating'},
  //         { path: 'card', components: () => import('@/views/authorityMge/card'), name: 'cardMge', meta: { title: 'cardMge' },setName:'V3_0_DeviceManage_AddDevice'}
  //       ]
  //     },
  //   },
  //   {
  //     name:'V3_0_IQManageCenter_DeviceManage',
  //     routes:{
  //       path: '',
  //       components: Layout,
  //       meta: { title: 'Devices', icon: 'icon', noCache: true },
  //       setName:'V3_0_IQManageCenter_DeviceManage',
  //       children: [{
  //         path: 'Devices',
  //         components: () => import('@/views/equipmentMge/index'),
  //         name: 'Devices',
  //         meta: { title: 'processorManager'}
  //       },
  //         { path: 'projectorCode', components: () => import('@/views/projectorDevices/index'), name: 'projectorCode', meta: { title: 'projectorCode'}},
  //         { path: 'interfaceRename', components: () => import('@/views/equipmentMge/editName'), name: 'interfaceRename', meta: { title: 'interfaceRename'}}
  //       ]
  //     },
  //   },
  //   {
  //     name:'V3_0_IQManageCenter_MediaDeviceManage',
  //     routes:{
  //       path: '/workstationMge',
  //       components: Layout,
  //       children: [{
  //         path: 'workstationMge',
  //         components: () => import('@/views/workstationMge/index'),
  //         name: 'workstationMge',
  //         meta: { title: 'workstationMge', icon: 'icon', noCache: true }
  //       }]
  //     },
  //   },
  //   {
  //     name:'V3_0_IQManageCenter_CloudSpaceManage',
  //     routes:{
  //       path: '/cloudDiskMge',
  //       components: Layout,
  //       redirect: 'cloudDiskMge',
  //       name: 'cloudDiskMge',
  //       meta: {
  //         title: 'cloudDiskMge',
  //         icon: 'component'
  //
  //       },
  //       children: [
  //         { path: 'cloudDiskMge', components: () => import('@/views/cloudDiskMge/index'), name: 'resourceMge', meta: { title: 'resourceMge' }},
  //         { path: 'storageMge', components: () => import('@/views/cloudDiskMge/storageMge'), name: 'storageMge', meta: { title: 'storageMge' }}
  //       ]
  //     },
  //   },
  //   {
  //     name:'V3_0_IQManageCenter_LoggerManage',
  //     routes:{
  //       path: '/operationLog',
  //       components: Layout,
  //       children: [{
  //         path: 'operationLog',
  //         components: () => import('@/views/operationLog/index'),
  //         name: 'operationLog',
  //         meta: { title: 'operationLog', icon: 'icon', noCache: true }
  //       }]
  //     }
  //   }
  //
  // ]
}



// WEBPACK FOOTER //
// ./src/views/permission/permission.js